import { gql } from '@apollo/client';

export const GET_DATA_AUDIT_UNITS = gql`
  query GetDataAuditUnits($input: GetDataAuditUnitsInput!) {
    getDataAuditUnits(input: $input) {
      periodStart
      periodEnd
      unitCount
      donorCount
      rows {
        productId
        productShortId
        unitType
        categoryId
        woocommerceProductId
        productStatus
        productCreatedAt
        donationId
        donorId
        donorShortId
        donorName
        ownerFullName
        donorLocation
        regionName
        donorStatus
      }
    }
  }
`;

export const GET_DATA_AUDIT_UNIT_DONORS = gql`
  query GetDataAuditUnitDonors($input: GetDataAuditUnitsInput!) {
    getDataAuditUnitDonors(input: $input) {
      periodStart
      periodEnd
      unitCount
      rows {
        donorId
        donorName
        ownerFullName
        donorLocation
        regionName
        donorStatus
        units
      }
    }
  }
`;

export const GET_DATA_AUDIT_RECRUITED_DONORS = gql`
  query GetDataAuditRecruitedDonors($input: GetDataAuditDonorsInput!) {
    getDataAuditRecruitedDonors(input: $input) {
      periodStart
      periodEnd
      donorCount
      rows {
        donorId
        donorName
        createdAt
        ownerFullName
        donorLocation
        regionName
        donorStatus
      }
    }
  }
`;

export const GET_OPS_LOCATION_UNITS = gql`
  query GetOpsLocationUnits($input: GetDataAuditUnitsInput!) {
    getOpsLocationUnits(input: $input) {
      periodStart
      periodEnd
      unitCount
      donorCount
      rows {
        productId
        productShortId
        unitType
        categoryId
        woocommerceProductId
        productStatus
        productCreatedAt
        donationId
        donorId
        donorShortId
        donorName
        ownerFullName
        ownerShortId
        donorLocation
        regionName
        donorStatus
        donationDate
      }
    }
  }
`;

export const GET_PRODUCT_UNIT_COUNTS = gql`
  query GetProductUnitCounts($input: GetProductUnitCountsInput!) {
    getProductUnitCounts(input: $input) {
      unitCount
      donorCount
    }
  }
`;

export const GET_DATA_AUDIT_PIPELINE_DONORS = gql`
  query GetDataAuditPipelineDonors($input: GetDataAuditDonorsInput!) {
    getDataAuditPipelineDonors(input: $input) {
      donorCount
      statuses
      rows {
        donorId
        donorName
        createdAt
        ownerFullName
        donorLocation
        regionName
        donorStatus
      }
    }
  }
`;

export const GET_REGISTRATION_DONORS = gql`
  query GetRegistrationDonors($input: GetRegistrationDonorsInput!) {
    getRegistrationDonors(input: $input) {
      donors {
        donorId
        donorShortId
        donorName
        ownerFullName
        ownerShortId
        bloodTypeDisplay
        status
        lastDonationDate
        sglDbl
        totalDonations
        periodUnits
        location
        registeredAt
        approvedDonationML
        weight
        ownerPhone
        ownerEmail
        ownerCity
        ownerState
        ownerContactPreferences
        ownerAssignedLocations
        breed
        dateOfBirth
        region
        activeDate
      }
      total
    }
  }
`;

export const GET_LEADERBOARD_HISTORY = gql`
  query GetLeaderboardHistory($input: GetLeaderboardHistoryInput!) {
    getLeaderboardHistory(input: $input) {
      weeks {
        weekNumber
        year
        weekEndDate
        winnerName
        winnerRegion
        winnerUserId
        recruitedCount
      }
    }
  }
`;
